var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-sider',{class:['sider',
           _vm.isDesktop ? null : 'shadow',
           _vm.navTheme === 'light' ? 'sider-light': null,
           _vm.fixSiderbar ? 'sider-fixed' : null ],style:(_vm.layoutSiderStyle),attrs:{"width":"208px","collapsed":_vm.sidebarCollapsed,"collapsible":true,"theme":_vm.navTheme,"trigger":null}},[_c('project-logo'),_c('div',{staticStyle:{"flex":"1","overflow-y":"auto","overflow-x":"hidden"}},[_c('side-menu',{attrs:{"mode":"inline","menus":_vm.menus,"collapsed":_vm.sidebarCollapsed,"collapsible":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }